import { render, staticRenderFns } from "./AdminTravelServiceAdditionalParamsPreview.vue?vue&type=template&id=3d25e33b&scoped=true&"
import script from "./AdminTravelServiceAdditionalParamsPreview.vue?vue&type=script&lang=js&"
export * from "./AdminTravelServiceAdditionalParamsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d25e33b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d25e33b')) {
      api.createRecord('3d25e33b', component.options)
    } else {
      api.reload('3d25e33b', component.options)
    }
    module.hot.accept("./AdminTravelServiceAdditionalParamsPreview.vue?vue&type=template&id=3d25e33b&scoped=true&", function () {
      api.rerender('3d25e33b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/AdminTravelServiceAdditionalParamsPreview.vue"
export default component.exports